<template>
    <div class="versions-module">
        <v-row>
            <v-col
                class="white"
            >
                <v-breadcrumbs
                    :items="[
                                {
                                    text: $t('navigation.administration'),
                                    disabled: true,
                                    href: 'breadcrumbs_dashboard',
                                },
                                {
                                    text: $t('navigation.documents'),
                                    disabled: true,
                                    href: 'documents',
                                },
                            ]"
                    class="mt-0 pt-0 pl-4"
                ></v-breadcrumbs>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                    <v-btn class="mb-2" color="primary" dark @click="openDialogCreateFolder">{{ $t('document.btn_new_folder') }}</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex
                                v-for="(folder, index) in folders"
                                :key="index" xs6 sm4 md2 class="text-left"
                            >
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs" v-on="on"
                                        size="52px"
                                        style="margin-right: 10px"
                                        :color="selectedFolder && selectedFolder.id === folder.id ? 'secondary' : '#FFD152'"
                                        @click="selectFolder(folder)"
                                    >
                                        {{ selectedFolder && selectedFolder.id === folder.id ? 'mdi-folder-open' : 'mdi-folder' }}
                                    </v-icon>
                                </template>
                                <span>{{ selectedFolder && selectedFolder.id === folder.id ? $t('document.close') : $t('document.open')}}</span>
                            </v-tooltip>

                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <label v-bind="attrs" v-on="on" @click="openDialogUpdateFolder(folder)">{{ folder.name }}</label>
                                </template>
                                <span>{{ $t('document.edit') }}</span>
                            </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        <v-dialog v-model="dialog" max-width="700px"
                                  @input="$validator.reset()"
                                  @click:outside="close">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="mb-2" color="primary" dark>{{ $t('document.btn_new_document') }}</v-btn>
                            </template>
                            <v-card
                                center
                            >
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-form>
                                        <v-text-field
                                            v-model="edited_document.name"
                                            :label="$t('document.name') + ' *'"
                                            hint="Requis"
                                            prepend-icon="mdi-alpha-n-box"
                                            :rules="[rules.required]"
                                            aria-required="true"
                                        ></v-text-field>
                                        <v-file-input
                                            accept=".pdf"
                                            data-vv-name="file"
                                            :label="$t('document.select_file')"
                                            prepend-icon="mdi-file"
                                            v-model="edited_document.file"
                                        ></v-file-input>
                                        <v-text-field
                                            v-if="edited_document.has_pdf"
                                            :value="edited_document.pdf_file"
                                            :label="$t('document.current_file')"
                                            maxlength="10000"
                                            readonly
                                            disabled
                                            prepend-icon="mdi-file"
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="edited_document.link"
                                            :label="$t('document.link')"
                                            prepend-icon="mdi-link"
                                            :rules="[rules.url]"
                                        ></v-text-field>
                                        <v-autocomplete
                                            v-model="logistic_area_ids"
                                            :items="logistic_areas"
                                            :filter="filter"
                                            :label="$t('tour.logistic_areas')"
                                            prepend-icon="mdi-target"
                                            item-value="id"
                                            item-text="name"
                                            multiple
                                        >
                                            <v-list
                                                v-if="isSelectAllAreasAvailable"
                                                slot="prepend-item"
                                                class="pa-0"
                                            >
                                                <v-list-item-group v-model="toggleAreas" class="d-flex align-center pa-0">
                                                    <v-list-item>
                                                        <v-list-item-icon class="mr-2">
                                                            <v-icon :color="logistic_area_ids.length > 0 ? 'primary' : ''">
                                                                {{ iconAreas }}
                                                            </v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ $t('global.select_all') }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <v-divider
                                                slot="prepend-item"
                                            ></v-divider>
                                            <template slot="item" slot-scope="data">
                                                {{ data.item.code }} ({{ data.item.name }})
                                            </template>
                                            <template v-slot:selection="{item, index}">
                                                <v-chip v-if="index <= 0">
                                                    {{item.code}}
                                                </v-chip>
                                                <span v-if="index === 1">(+ {{logistic_area_ids.length - 1}})</span>
                                            </template>
                                        </v-autocomplete>
                                        <v-autocomplete
                                            v-model="transporter_ids"
                                            :items="transporters"
                                            :filter="filter"
                                            :label="$t('navigation.transporters')"
                                            prepend-icon="mdi-lan"
                                            item-value="id"
                                            item-text="name"
                                            multiple
                                        >
                                            <v-list
                                                v-if="isSelectAllTransportersAvailable"
                                                slot="prepend-item"
                                                class="pa-0"
                                            >
                                                <v-list-item-group
                                                    v-model="toggleTransporters"
                                                    class="d-flex align-center pa-0">
                                                    <v-list-item>
                                                        <v-list-item-icon class="mr-2">
                                                            <v-icon
                                                                :color="transporter_ids.length > 0 ? 'primary' : ''">
                                                                {{ iconTransporters }}
                                                            </v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ $t('global.select_all') }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <v-divider
                                                slot="prepend-item"
                                            ></v-divider>
                                            <template slot="item" slot-scope="data">
                                                {{ data.item.code }} ({{ data.item.name }})
                                            </template>
                                            <template v-slot:selection="{item, index}">
                                                <v-chip v-if="index <= 0">
                                                    {{item.code}}
                                                </v-chip>
                                                <span
                                                    v-if="index === 1">(+{{transporter_ids.length - 1}})</span>
                                            </template>
                                        </v-autocomplete>
                                        <v-autocomplete
                                            v-model="driver_ids"
                                            :items="drivers"
                                            :label="$t('navigation.drivers')"
                                            prepend-icon="mdi-truck"
                                            item-value="id"
                                            item-text="name"
                                            multiple
                                        >
                                            <v-list
                                                v-if="isSelectAllDriversAvailable"
                                                slot="prepend-item"
                                                class="pa-0"
                                            >
                                                <v-list-item-group
                                                    v-model="toggleDrivers"
                                                    class="d-flex align-center pa-0">
                                                    <v-list-item>
                                                        <v-list-item-icon class="mr-2">
                                                            <v-icon
                                                                :color="driver_ids.length > 0 ? 'primary' : ''">
                                                                {{ iconDrivers }}
                                                            </v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ $t('global.select_all') }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list>
                                            <v-divider
                                                slot="prepend-item"
                                            ></v-divider>
                                            <template slot="item" slot-scope="data">
                                                {{ data.item.name }}
                                            </template>
                                            <template v-slot:selection="{item, index}">
                                                <v-chip v-if="index <= 0">
                                                    {{item.name}}
                                                </v-chip>
                                                <span v-if="index === 1">(+{{driver_ids.length - 1}})</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-autocomplete
                                            v-model="folder_ids"
                                            :items="folders"
                                            :filter="filter"
                                            :label="$t('navigation.folders')"
                                            prepend-icon="mdi-folder"
                                            item-value="id"
                                            item-text="name"
                                            clearable
                                        >
                                            <v-divider
                                                slot="prepend-item"
                                            ></v-divider>
                                            <template slot="item" slot-scope="data">
                                                {{ data.item.name }}
                                            </template>
                                            <template v-slot:selection="{item, index}">
                                                <v-chip v-if="index <= 0">
                                                    {{item.name}}
                                                </v-chip>
                                                <span
                                                    v-if="index === 1">(+{{folder_ids.length - 1}})</span>
                                            </template>
                                        </v-autocomplete>
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="formattedDate"
                                                    :label="$t('document.expiration_date')"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    clearable
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="clearDate"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="edited_document.expiration_date"
                                                :min="today"
                                                locale="fr"
                                                no-title
                                                @input="menu = false"
                                            ></v-date-picker>
                                        </v-menu>

                                        <v-text-field
                                            v-if="edited_document.id !== undefined"
                                            :value="edited_document.last_update|moment('L LT')"
                                            :label="$t('document.last_update')"
                                            maxlength="10000"
                                            readonly
                                            disabled
                                            prepend-icon="mdi-calendar"
                                        ></v-text-field>
                                        <v-checkbox
                                            :label="$t('document.must_be_read')"
                                            v-model="edited_document.must_be_read"
                                        ></v-checkbox>
                                        <v-checkbox
                                            :label="$t('document.actif')"
                                            v-model="edited_document.actif"
                                        ></v-checkbox>
                                        <v-textarea
                                            v-model="edited_document.comment"
                                            :label="$t('document.comment')"
                                            outlined
                                            prepend-icon="mdi-message"
                                        ></v-textarea>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close">{{ $t('user.cancel') }}</v-btn>
                                    <v-btn @click="save"
                                           elevation="0"
                                           color="primary"
                                           :disabled="!formIsValid">
                                        Enregistrer
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table
                        :loading="document_loading"
                        :headers="headers"
                        :items="documents"
                    >
                        <template v-slot:item.comment="{ item }">
                            <p style="white-space: pre-wrap"
                               class="mt-4"
                               v-html="item.comment"></p>
                        </template>
                        <template #[`item.last_update`]="{item}">
                            {{item.last_update | moment('L LT')}}
                        </template>
                        <template #[`item.actif`]="{item}">
                            {{item.actif ? 'Oui' :'Non'}}
                        </template>
                        <template #[`item.must_be_read`]="{item}">
                            {{item.must_be_read ? 'Oui' :'Non'}}
                        </template>
                        <template #[`item.action`]="{item}">
                            <a v-if="item.has_pdf"
                               :href="`storage/${item.pdf_id}/${item.pdf_file}`"  download>
                                <v-icon
                                    class="mr-2"
                                    small
                                >
                                    mdi-eye
                                </v-icon>
                            </a>
                                <v-icon
                                    disabled
                                    v-else
                                    class="mr-2"
                                    small
                                >
                                    mdi-eye
                                </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                :title="$t('version.edit')"
                                @click="showFile(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                :title="$t('version.delete')"
                                @click="openDeleteModal(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card>
                <v-snackbar
                    v-model="snackbar"
                    top
                    :color="snackbar_type"
                >
                    {{ snackbar_text }}
                    <v-btn
                        text
                        @click="snackbar = false"
                    >
                        Close
                    </v-btn>
                </v-snackbar>
                <v-dialog v-model="dialogDelete" max-width="290">
                    <v-card elevation="0">
                        <v-card-title class="headline">{{ $t('repository.sure') }}</v-card-title>
                        <v-card-text>{{ $t('repository.irremediable') }}</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="darken-1" text @click="dialogDelete = false">
                                {{ $t('repository.cancel') }}
                            </v-btn>
                            <v-btn color="warning darken-1" text
                                   :loading="deleteLoading"
                                   @click="deleteDocument(edited_document.id)">
                                {{ $t('repository.delete') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>

        <!-- Dialog : création d'un dossier -->
        <v-dialog v-model="dialogCreateFolder" max-width="500px" persistent>
            <v-card>
                <v-card-title class="headline">Nouveau dossier</v-card-title>
                <v-card-text>
                <v-text-field
                    v-model="newFolderName"
                    label="Nom *"
                    :error-messages="erreurName"
                    @input="erreurName = ''"
                    prepend-icon="mdi-folder"
                    clearable
                ></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-end">
                <v-btn color="blue darken-1" text @click="closeDialogCreateFolder">{{ $t('repository.cancel') }}</v-btn>
                <v-btn @click="createFolder">{{ $t('repository.new') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog : Edition d'un dossier (modification du libellé / suppression du dossier) -->
        <v-dialog v-model="dialogUpdateFolder" max-width="500px" persistent>
            <v-card>
                <v-card-title class="headline">Édition dossier</v-card-title>
                <v-card-text>
                <v-text-field
                    v-model="currentFolder.name"
                    label="Nom *"
                    :error-messages="erreurName"
                    @input="erreurName = ''"
                    prepend-icon="mdi-folder"
                    clearable
                ></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn color="blue darken-1" text @click="closeDialogUpdateFolder">{{ $t('repository.cancel') }}</v-btn>
                    <v-btn @click="updateFolder">{{ $t('repository.update') }}</v-btn>
                    <v-btn color="warning darken-1" text
                            @click="deleteFolder">
                        {{ $t('repository.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {LOGISTIC_AREAS, TRANSPORTERS, USERS, FOLDERS, DOCUMENTS, DOCUMENTS_FOLDER} from "../api";

export default {
    name: "Documents",
    data(){
        return{
            dialogCreateFolder: false,
            dialogUpdateFolder: false,
            newFolderName: '',
            currentFolder: {
                id: null,
                name: ''
            },
            erreurName: '',
            information: '',
            selectedFolder: null,
            folders: [],
            folder_ids:[],
            menu: false,
            today: this.formatDate(new Date()), // Format YYYY-MM-DD

            document_loading: false,
            dialog: false,
            documents:[],
            edited_document: {
                name:"",
                comment:  "",
                link: null,
                ressource_updated_datetime:null,
                file: null,
                must_be_read: false,
                actif: true,
                has_pdf:false,
                affectations:[],
                folder_id: null,
                expiration_date: null
            },

            template: {
                name:"",
                comment:  "",
                link: null,
                ressource_updated_datetime:null,
                file: null,
                must_be_read: false,
                actif: true,
                has_pdf:false,
                affectations:[],
                folder_id: null,
                expiration_date: null
            },

            transporter_ids:[],
            driver_ids:[],
            logistic_area_ids:[],

            snackbar: false,
            snackbar_text: '',
            snackbar_type: null,

            save_loading: false,

            headers:[
                {
                    text: 'Nom',
                    value:'name',
                    sortable: false,
                },{
                    text: 'Lien',
                    value:'link',
                    sortable: false,
                },{
                    text: 'Dernière modification',
                    value:'last_update',
                    sortable: false,
                },
                {
                    text: 'Commentaire',
                    value:'comment',
                    sortable: false,
                },
                {
                    text: 'Actif',
                    value:'actif',
                    sortable: false,
                },
                {
                    text: 'Obligatoire',
                    value:'must_be_read',
                    sortable: false,
                },
                {
                    text: 'Actions',
                    value:'action',
                    sortable: false,
                }
            ],

            transporters:[],
            drivers:[],
            logistic_areas:[],

            toggleAreas: null,
            searchAreasInput:null,

            toggleDrivers: null,
            searchDriversInput:null,

            toggleTransporters: null,
            searchTransportersInput:null,

            dialogDelete: false,
            deleteLoading: false,

            rules:{
                required: value => !!value || 'Requis',
                url: value => {
                    const pattern = /^(https|http):\/\/([a-z\d_]+\.)?(([a-zA-Z\d_]+)(\.[a-zA-Z]{2,6}))(\/[a-zA-Z\d_\%\-=\+]+)*(\?)?([a-zA-Z\d=_\+\%\-&\{\}\:]+)?/
                    return (pattern.test(value) || value?.length === 0) || 'Lien invalide'
                }
            }
        }
    },
    mounted() {
        this.getFolders()
        this.getDocuments()
        this.getDriverUsers()
        this.getTransporters()
        this.getLogisticAreas()
    },
    computed:{
        formTitle(){
            return this.edited_document?.id ? 'Modifier le Document' : 'Ajouter un Document'
        },
        current(){
            return this.edited_document
        },
        formIsValid(){
                // à un document, des assignations et un nom
              return this.hasOneDocument && this.hasAtLeastOnAssignation && this.edited_document.name !== ''
        },
        hasOneDocument(){
            return (this.current.file || this.current.has_pdf) || this.current.link
        },
        hasAtLeastOnAssignation(){
            return this.transporter_ids.length > 0
                || this.driver_ids.length > 0
                || this.logistic_area_ids.length > 0
        },

        //ZL
        iconAreas() {
            if (this.allAreas) return 'mdi-close-box'
            if (this.someAreas) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        isSelectAllAreasAvailable() {
            return this.searchAreasInput === '' || this.searchAreasInput === null;
        },
        allAreas() {
            return this.logistic_area_ids.length === this.logistic_areas.length
        },
        someAreas() {
            return this.logistic_area_ids.length > 0 && !this.allAreas
        },

        //Driver
        iconDrivers() {
            if (this.allDrivers) return 'mdi-close-box'
            if (this.someDrivers) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        isSelectAllDriversAvailable() {
            return this.searchDriversInput === '' || this.searchDriversInput === null;
        },
        allDrivers() {
            return this.driver_ids.length === this.drivers.length
        },
        someDrivers() {
            return this.driver_ids.length > 0 && !this.allDrivers
        },

        // transporters
        iconTransporters() {
            if (this.allTransporters) return 'mdi-close-box'
            if (this.someTransporters) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        isSelectAllTransportersAvailable() {
            return this.searchTransportersInput === '' || this.searchTransportersInput === null;
        },
        allTransporters() {
            return this.transporter_ids.length === this.transporters.length
        },
        someTransporters() {
            return this.transporter_ids.length > 0 && !this.allTransporters
        },

        // Date d'expiration du document
        formattedDate: {
            get() {
                if (!this.edited_document.expiration_date) return '';
                return new Date(this.edited_document.expiration_date).toLocaleDateString('fr-FR');
            },
            set(value) {
                this.edited_document.expiration_date = value;
            },
        },
    },
    methods:{
        getDocuments(){
            this.document_loading = true
            this.axios.get(DOCUMENTS)
                .then(res => {
                    this.documents = res.data.data

                    if(this.selectedFolder === null) {
                        this.documents = this.documents.filter(o => o.folder_id === null)
                    } else {
                        this.documents = this.documents.filter(o => o.folder_id === this.selectedFolder.id)
                    }
                })
                .catch(err => {})
                .finally(() => {
                    this.document_loading = false
                })
        },
        close(){
            this.dialog = false
            this.edited_document = structuredClone(this.template)
            this.logistic_area_ids = []
            this.driver_ids = []
            this.transporter_ids = []
            this.folder_ids = []
            this.getDocuments()
        },
        showFile(file){
            this.dialog = true
            this.edited_document = structuredClone(file)
            this.logistic_area_ids = file.affectations.find(item => {return item.group === 'logistic_area'})?.ids ?? []
            this.driver_ids = file.affectations.find(item => {return item.group === 'user'})?.ids ?? []
            this.transporter_ids = file.affectations.find(item => {return item.group === 'transporter'})?.ids ?? []
            this.folder_ids = file.folder_id ?? null
        },
        isAnUpdate(){
            return this.edited_document?.id > 0
        },
        openDeleteModal(file){
            this.dialogDelete = true
            this.edited_document = structuredClone(file)
        },
        async deleteDocument(id){
            try {
                this.deleteLoading = true
                await this.axios.delete(`/api/documents/${id}`)
                this.getDocuments()
                this.dialogDelete = false
            }catch (e) {
                this.showSnackbar('error', this.$t('document.delete_fail'));
            }
            finally {
                this.deleteLoading = false
            }
        },
        async getLogisticAreas(){
          const data = (await axios.get(LOGISTIC_AREAS)).data
          this.logistic_areas = data
        },
        async getDriverUsers(){
          const data = (await axios.get(USERS + '?filter[roles]=driver')).data
          this.drivers = _.sortBy(data, ['name'])
        },
        async getTransporters(){
          const data = (await axios.get(TRANSPORTERS)).data
            this.transporters = _.sortBy(data, ['code'])
        },
        async getFolders(){
            try {
                const data = (await axios.get(FOLDERS)).data
                // this.folders = _.sortBy(data, ['name']) // Ne tiens pas compte des accents
                this.folders = this.sortInsensitive(data, 'name');
            } catch (error) {
                console.error('Erreur chargement des folders', error)
            }
        },
        sortInsensitive(array, key = 'name') {
            // On tri le tableau en fonction du champ Name en ignorant les accents
            return array.slice().sort((a, b) => this.compareInsensitive(a[key], b[key]));
        },
        compareInsensitive(a, b) {
            // Compare deux chaînes en ignorant les accents et la casse
            // Ici normalize('NFD') + replace(...) constituent l'approche standard ECMAScript pour retirer les accents de tous les caractères latins accentués usuels.
            return a
                .normalize('NFD')                  // Décompose les accents
                .replace(/[\u0300-\u036f]/g, '')   // Supprime les diacritiques
                .toLowerCase()
                .localeCompare(
                b
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()
                );
        },
        async save(){
            if (!this.formIsValid){
                return
            }

            const payload = this.buildPayload()

            try {
                this.save_loading = true
                if (this.isAnUpdate()){
                    await
                        axios.post('/api/documents/' + this.edited_document.id, payload)
                } else {
                    await axios.post('/api/documents', payload)
                }
                this.showSnackbar('success', this.$t('document.updated_success'));
                this.close()
            } catch (e) {
                this.showSnackbar('error', this.$t('document.update_has_fail'));
            } finally {
                this.save_loading= false
            }

        },
        buildPayload(){
            let formData = new FormData();

            formData.append('name', this.edited_document.name)

            if (this.edited_document.file){
                formData.append("file", this.edited_document.file);
            }

            if (this.edited_document.comment){
                formData.append('comment', this.edited_document.comment)
            } else {
                formData.append('comment', " ")
            }

            if (this.edited_document.link){
                formData.append('link', this.edited_document.link)
            } else {
                formData.append('link', " ")
            }

            if (this.folder_ids) {
                formData.append('folder_id', this.folder_ids)
            } else {
                // /!\ Ne pas assigner « null » ici sinon cela sera traduit comme « "null" » par FormRequest
                formData.append('folder_id', '')
            }

            if (this.edited_document.expiration_date) {
                formData.append('expiration_date', this.edited_document.expiration_date)
            } else {
                formData.append('expiration_date', '')
            }

            formData.append('actif', this.edited_document.actif ? 1 : 0)
            formData.append('must_be_read', this.edited_document.must_be_read ? 1 : 0)

            let affectations = []
            if (this.logistic_area_ids?.length > 0)
                affectations.push({group: 'logistic_area', ids: this.logistic_area_ids})
            if (this.driver_ids?.length > 0)
                affectations.push({group: 'user', ids: this.driver_ids})
            if (this.transporter_ids?.length > 0)
                affectations.push({group: 'transporter', ids: this.transporter_ids})

            formData.append('affectations', JSON.stringify(affectations))

            return formData
        },
        showSnackbar(type, text) {
            this.snackbar_type = type;
            this.snackbar_text = text;
            this.snackbar = true;
        },
        filter(item, queryText, itemText){
          queryText = queryText.toLocaleLowerCase()
          return item?.name?.toLocaleLowerCase().includes(queryText) ||
              item?.code?.toLocaleLowerCase().includes(queryText)
        },
        selectFolder(folder) {
            this.selectedFolder =
                this.selectedFolder && this.selectedFolder.id === folder.id
                ? null
                : folder

            this.getDocuments()
        },
        async createFolder() {
            const name = this.newFolderName.trim()
            if (!name) {
                this.erreurName = 'Le champ Nom est obligatoire'
                return
            }

            const exists = this.folders.some(
                d => d.name.toLowerCase() === name.toLowerCase()
            )
            if (exists) {
                this.erreurName = 'Ce nom de dossier existe déjà'
                return
            }

            try {
                const response = await axios.post(FOLDERS, { name })
                this.folders.push(response.data)

                this.closeDialogCreateFolder()
                this.showSnackbar('success', this.$t('folder.created_success'));
            } catch (e) {
                if (e.response?.data?.errors?.name) {
                    this.erreurName = e.response.data.errors.name[0]
                } else {
                    this.erreurName = 'Erreur lors de la création du dossier'
                }

                this.showSnackbar('error', this.$t('folder.create_has_fail'));
            }
        },
        async deleteFolder() {
            if(!this.currentFolder) return

            const canBeDeleted = await this.canBeDeleted(this.currentFolder.id)
            if (canBeDeleted) {
                try {
                    await axios.delete(`${FOLDERS}/${this.currentFolder.id}`);
                    this.folders = this.folders.filter(d => d.id !== this.currentFolder.id);
                    this.closeDialogUpdateFolder();
                    this.showSnackbar('success', this.$t('folder.deleted_success'));
                } catch (e) {
                    this.showSnackbar('error', this.$t('folder.delete_has_fail'));
                }
            } else {
                this.showSnackbar('error', this.$t('folder.not_empty'));
            }
        },
        async canBeDeleted(folder_id) {
            try
            {
                const res = await axios.get(this.replacePathParams(DOCUMENTS_FOLDER, { folder_id }));
                return res.data?.length === 0;
            } catch (e) {
                return false;
            }
        },
        async updateFolder() {
            if(!this.currentFolder) return

            const id = this.currentFolder.id
            const name = this.currentFolder.name?.trim()
            if (!name) {
                this.erreurName = 'Le champ Nom est obligatoire'
                return
            }

            const exists = this.folders.some(
                d => d.name.toLowerCase() === name.toLowerCase() && d.id !== id
            )
            if (exists) {
                this.erreurName = 'Ce nom de dossier existe déjà'
                return
            }

            try {
                await axios.put(`${FOLDERS}/${id}`, { id, name })

                this.closeDialogUpdateFolder()
                this.showSnackbar('success', this.$t('folder.updated_success'));
            } catch (e) {
                if (e.response?.data?.errors?.name) {
                    this.erreurName = error.response.data.errors.name[0]
                } else {
                    this.erreurName = 'Erreur lors de la modification du dossier'
                }

                this.showSnackbar('error', this.$t('folder.update_has_fail'));
            }
        },
        openDialogCreateFolder() {
            this.erreurName = ''
            this.newFolderName = ''
            this.dialogCreateFolder = true
        },
        openDialogUpdateFolder(folder) {
            this.erreurName = ''
            this.currentFolder = folder
            this.dialogUpdateFolder = true
        },
        closeDialogCreateFolder(){
            this.erreurName = ''
            this.newFolderName = ''
            this.dialogCreateFolder = false;
        },
        closeDialogUpdateFolder(){
            this.getFolders()
            this.erreurName = ''
            this.currentFolder = { id: null, name: '' }
            this.dialogUpdateFolder = false
        },
        clearDate() {
            this.edited_document.expiration_date = null;
        },
        formatDate(date) {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },
    },
    watch: {
        toggleAreas() {
            this.$nextTick(() => {
                if (this.allAreas) {
                    this.logistic_area_ids = []
                } else {
                    this.logistic_areas.forEach(element => {
                        if (!this.logistic_area_ids.includes(element.id)) {
                            this.logistic_area_ids.push(element.id);
                        }
                    });
                }
            })
        },
        toggleDrivers() {
            this.$nextTick(() => {
                if (this.allDrivers) {
                    this.driver_ids = []
                } else {
                    this.drivers.forEach(element => {
                        if (!this.driver_ids.includes(element.id)) {
                            this.driver_ids.push(element.id);
                        }
                    });
                }
            })
        },
        toggleTransporters() {
            this.$nextTick(() => {
                if (this.allTransporters) {
                    this.transporter_ids = []
                } else {
                    this.transporters.forEach(element => {
                        if (!this.transporter_ids.includes(element.id)) {
                            this.transporter_ids.push(element.id);
                        }
                    });
                }
            })
        },
    },
}
</script>

<style scoped></style>
